import getUsersISOLocale from 'utils/i18n/getUsersISOLocale';

/**
 * Takes a plain time string eg HH:MM:SS and returns a localised time string
 */

function getLocalisedTime(time) {
  var userLocale = getUsersISOLocale();
  var hour = parseInt(time.split(':')[0]);
  var minute = parseInt(time.split(':')[1]);
  var date = new Date(0, 0, 0, hour, minute);
  var localisedTime = new Intl.DateTimeFormat(userLocale, {
    timeStyle: 'short'
  }).format(date);
  return localisedTime;
}
export default getLocalisedTime;